export default __webpack_public_path__ + "static/media/button-icon-edit.9eacf7a3.svg";